import React from "react";
import "./ActivateDevResult.scss";
import { Button } from "@material-ui/core";
import { Route } from "react-router-dom";
import { GoogleTagManagerService } from "../../../../services/analitycs/GoogleTagManagerService";
import ResultOkIcon from "../../../../resources/wrappers/ResultOk";
import ResultKoIcon from "../../../../resources/wrappers/ResultKo";
import { MposWebPortalApi } from "../../../../services/api/MposWebPortalApi";
import { HTTPResponses } from "../../../../models/HTTPResponses";

export class RegisterDevResult extends React.Component<any, any> {
  private email: string | undefined;
  private revokeDeveloperFlow: boolean | undefined;

  constructor(props: any) {
    super(props);
    this.state = {
      retryEnabled: true,
      icon: undefined,
      title: undefined,
      message: undefined,
      isSuccess: this.props.location.state.isSuccess,
    };
    this.email = this.props.location.state.email;
    this.revokeDeveloperFlow = this.props.location.state.revokeDeveloperFlow ? this.props.location.state.revokeDeveloperFlow : false;
  }

  componentDidMount(): void {
    this.showResult();
    GoogleTagManagerService.getInstance().pushInteractionEvent('popupImpression', 'Popup', 'impression', 'abilita utenza: abilita utenza sviluppatore: esito positivo');
  }

  private showResult() {
    if (this.state.isSuccess && this.email) {
      this.setState({
        title: this.revokeDeveloperFlow ?
          <>Hai revocato con successo l’abilitazione di {this.props.location.state?.email}</> :
          <>Hai aggiunto uno sviluppatore al tuo staff!</>,
        message: this.revokeDeveloperFlow ?
          <>L’utente non potrà più accedere all’area sviluppatori.</> :
          (
            <>
              Abbiamo inviato una notifica all'indirizzo
              <br className="hide-on-mobile" /> <b>{this.email}</b>. Da ora potrà configurare
              <br className="hide-on-mobile" /> gli ID Terminale del punto vendita all'interno della propria
              <br className="hide-on-mobile" /> soluzione software.
              <p>Ricorda che puoi revocare in qualsiasi momento tale
                <br className="hide-on-mobile" /> abilitazione eliminando l'utenza.
              </p>
            </>
          ),
      });
    } else {
      this.setState({
        title: this.revokeDeveloperFlow ?
          <>Problema durante la revoca dell’utenza</> :
          <>Problema durante l'abilitazione dell'utenza sviluppatore</>,
        message: this.revokeDeveloperFlow ?
          <>Abbiamo riscontrato un problema durante la revoca dell’utenza. Riprova.</> :
          <>Abbiamo riscontrato un problema durante l'abilitazione. Riprova.</> ,
      });
    }
  }

  private retry() {
    this.setState({ retryEnabled: false }, () => {
      if (this.revokeDeveloperFlow) {
        MposWebPortalApi.getInstance()
          .removeDeveloper(this.email ?? "")
          .subscribe((result) => {
            switch (result) {
              case HTTPResponses.OK:
                this.setState(
                  {
                    isSuccess: true,
                  },
                  );
                  this.showResult()
                break;
              case HTTPResponses.KO:
              default:
                this.setState(
                  { isSuccess: false },
                  () => {
                    this.showResult();
                    setTimeout(() => {
                      this.setState({ retryEnabled: true });
                    }, 1000);
                  }
                );
                break;
            }
          });
      } else {
        MposWebPortalApi.getInstance()
          .addDeveloper(this.email ?? "")
          .subscribe((result) => {
            switch (result) {
              case HTTPResponses.OK:
                this.setState(
                  {
                    isSuccess: true,
                  },
                  );
                  this.showResult()
                break;
              case HTTPResponses.NOT_FOUND:
              case HTTPResponses.KO:
              default:
                this.setState(
                  { isSuccess: false },
                  () => {
                    this.showResult();
                    setTimeout(() => {
                      this.setState({ retryEnabled: true });
                    }, 1000);
                  }
                );
                break;
            }
          });
      }
    });
  }

  render() {
    return (
      <div className={"activate-dev-result-main-container"}>
        <div className={"activate-dev-result-page-unauth-main-content"}>
          <div className="activate-dev-result-unauth">
            {this.state?.isSuccess || this.props.location.state.isSuccess ? (
              <ResultOkIcon width="60px" heigth="60px" color="#2D32AA" />
            ) : (
              <ResultKoIcon width="60px" heigth="60px" color="#2D32AA" />
            )}
            <p className={"activate-dev-result-unauth-title-error"}>{this.state.title}</p>
            <p className="activate-dev-result-unauth-message">{this.state.message}</p>
          </div>
        </div>
        <div className={"activate-dev-buttons-container"}>
          {!(this.state.isSuccess && this.email) && (
            <>
              <Button id={"activate-dev-submit-button"} disabled={!this.state.retryEnabled} type={"submit"} onClick={() => this.retry()}>
                RIPROVA
              </Button>
            </>
          )}
          <Route
            render={({ history }) => (
              <Button id={`${!(this.state.isSuccess && this.email) ? "activate-dev-submit-button-secondary" : "activate-dev-go-to-next-step-button"}`} type={"submit"} onClick={() => history.push("/")}>
                TORNA ALLA HOME
              </Button>
            )}
          />
        </div>
      </div>
    );
  }
}

export default RegisterDevResult;
